import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { getSliders } from "../../../services/SlidersServices";
import { Autoplay, Navigation, Pagination, Mousewheel, Keyboard } from "swiper";
import { Box, Skeleton } from "@mui/material";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const HeaderBanner = () => {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const res = await getSliders();
      if (res) setSliders(res.map(i => ({ ...i, imagen: `${process.env.REACT_APP_URL_BACKEND}${i.imagen}` })));
      setLoading(false);
    })();
  }, []);

  if (loading) return (
    <Box sx={{ width: "100%", px: { xs: 1.5, md: 3 }, pt: { xs: 1.5, md: 2.5 } }}>
      <Skeleton variant="rounded" sx={{ width: "100%", aspectRatio: { xs: "16/7", md: "3/1" }, borderRadius: { xs: "12px", md: "16px" } }} />
    </Box>
  );

  if (!sliders.length) return null;

  return (
    <Box sx={{ width: "100%", px: { xs: 1.5, md: 3 }, pt: { xs: 1.5, md: 2.5 } }}>
      <Box sx={{
        width: "100%",
        borderRadius: { xs: "12px", md: "16px" },
        overflow: "hidden",
        boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        aspectRatio: { xs: "16/7", sm: "21/9", md: "3/1" },
        position: "relative",
      }}>
        <Swiper
          loop
          navigation
          pagination={{ clickable: true, dynamicBullets: true }}
          modules={[Autoplay, Navigation, Pagination, Mousewheel, Keyboard]}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          speed={800}
          style={{ height: "100%", width: "100%" }}
        >
          {sliders.map((s) => {
            const href = s.url ? (s.url.startsWith("http") ? s.url : `https://${s.url}`) : null;
            const img = (
              <Box
                component="img"
                src={s.imagen}
                alt={s.descripcion || "slide"}
                sx={{ width: "100%", height: "100%", objectFit: "cover", cursor: href ? "pointer" : "default", display: "block" }}
              />
            );
            return (
              <SwiperSlide key={s.id}>
                {href
                  ? <a href={href} target={s.target === "_self" ? "_self" : "_blank"} rel={s.target === "_self" ? undefined : "noopener noreferrer"} style={{ display: "block", width: "100%", height: "100%" }}>{img}</a>
                  : img
                }
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Box>
    </Box>
  );
};

export default HeaderBanner;